import React, { memo, useCallback, useState } from 'react';

import { SwitchAccount } from 'components/SwitchAccount';
import { useSelector } from 'react-redux';
import { ERROR_IMAGE } from 'settings';
import { selectUser, selectUserIsClubeBlack } from 'store/selectors';

import { Container, ImgContainer, UserInfoContainer } from './styles';

function Profile() {
  const { name, photo } = useSelector(selectUser);
  const isClubeBlack = useSelector(selectUserIsClubeBlack);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleMenu = useCallback(() => {
    setIsOpen(prev => !prev);
  }, [setIsOpen]);

  return (
    <Container isClubeBlack={isClubeBlack} onClick={toggleMenu}>
      <ImgContainer>
        <img
          src={photo}
          alt={`Imagem de ${name}`}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = ERROR_IMAGE;
          }}
        />
      </ImgContainer>
      <UserInfoContainer>
        <p>Bem vindo</p>
        <span>{name}</span>
      </UserInfoContainer>

      <SwitchAccount isOpen={isOpen} />
    </Container>
  );
}

export default memo(Profile);
